.verticalContent {
    display: block;
}
